<template>
<svg viewBox="0 0 48 48" fill="none" :class="[`${prefix}-icon`, `${prefix}-icon-calendar-fill-123`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M22.62 3.001a1.8 1.8 0 012.198.272l9.476 9.475a1.8 1.8 0 11-2.546 2.546l-8.26-8.261-7.67 7.67a1.8 1.8 0 01-2.545-2.545L22.04 3.39c.156-.156.334-.278.524-.365l.055-.024z" :fill="useCurrentColor ? 'currentColor' : '#2B2F36'"/><path fill-rule="evenodd" clip-rule="evenodd" d="M4 12h40a2 2 0 012 2v28a2 2 0 01-2 2H4a2 2 0 01-2-2V14a2 2 0 012-2z" :fill="useCurrentColor ? 'currentColor' : '#2B2F36'"/><path fill-rule="evenodd" clip-rule="evenodd" d="M25 30a1 1 0 011 1v2a1 1 0 01-1 1H15a1 1 0 01-1-1v-2a1 1 0 011-1h10zm8-8a1 1 0 011 1v2a1 1 0 01-1 1H15a1 1 0 01-1-1v-2a1 1 0 011-1h18z" :fill="useCurrentColor ? 'currentColor' : '#fff'"/></svg>
</template>
<script>

export default {
  name: 'IconCalendarFill123',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
